import { compose } from 'redux';
import { connect } from 'react-redux';
import * as Action from '../../../actions/AdminCompanyManagement';
import DetailCompany from '../../../pages/Admin/CompanyManagement/DetailCompany';
import withAuth from '../../../common/WithAuth';
import DetailCompanySelector from '../../../selectors/AdminCompanyManagement';
import { GetZonesRequested } from '../../../actions/CommonOptions';

const createDetailCompanySelector = DetailCompanySelector.createDetailCompanySelector();

const mapStateToProps = (state) => {
    const isLoading = state.adminCompanyManagement.detailCompany.isFetching
    || state.adminCompanyManagement.editCompany.isFetching
    || state.commonOptions.zones.isFetching;

    return ({
        locale: state.locale.lang.current,
        companyDetail: createDetailCompanySelector(state),
        editSuccess: state.adminCompanyManagement.editCompany.editSuccess,
        eventInfo: state.eventManagement.infoEvent.data,
        isLoading,
        options: state.commonOptions.Options.data,
        zones: state.commonOptions.zones.data,
    });
};

const mapDispatchToProps = (dispatch) => ({
    getDetailCompany: (params) => dispatch(Action.GetDetailCompanyRequested(params)),
    fetchClearEditCompany: () => dispatch(Action.ClearEditCompany()),
    fetchClearGetDetailCompany: () => dispatch(Action.ClearGetDetailCompany()),
    fetchEventZones: (shortName) => dispatch(GetZonesRequested(shortName)),
});

export default compose(
    withAuth,
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
)(DetailCompany);
